import React from "react";
import { useTranslation } from "react-i18next";
import { formatDuration, shouldShowDuration } from "./elapsedTime";
import "./ActivityStepInline.css";

// Pill persistente que fica na mensagem depois que a resposta final já apareceu (diferente
// do ActivityStepInline, que só existe enquanto a execução está em andamento e some quando o
// texto final chega). Cobre o buraco identificado em 2026-08-26: sem ele, uma vez fechado o
// painel "Atividade" depois da execução terminada, não havia mais nenhum jeito de reabri-lo -
// referência visual: Figma IRIS-APP, "Frame 6484" ("Pensou por N segundos").
function ActivityStepSummary({ summary, onClick, hideCaret = false }) {
  const { t: tChat } = useTranslation("chat");

  if (!summary) {
    return null;
  }

  const isClickable = typeof onClick === "function";

  return (
    <button
      type="button"
      className="ActivityStepSummary"
      data-testid="activity-step-summary"
      onClick={isClickable ? onClick : undefined}
      disabled={!isClickable}
    >
      <span
        className="ActivityStepSummary-text"
        data-testid="activity-step-summary-text"
      >
        {summary.skill_name
          ? tChat("activityStepSkillDone", { name: summary.skill_name })
          : tChat("activityStepSummaryGeneric")}
        {shouldShowDuration(summary.duration_ms / 1000) && (
          // Tarefa 9 (FR-019): tempo total (congelado) da execução inteira.
          <span data-testid="activity-step-summary-duration">
            {" "}
            · {formatDuration(summary.duration_ms / 1000)}
          </span>
        )}
      </span>
      {!hideCaret && (
        <span className="ActivityStepSummary-caret" aria-hidden="true">
          ›
        </span>
      )}
    </button>
  );
}

export default ActivityStepSummary;
